import { lazy } from 'react';

const CollectionRoutes = [
    {
        path: '/language',
        component: lazy(() => import('../../pages/Collections/Language')),
        meta: {
            action: 'read',
            resource: 'collections',
        },
    },
    {
        path: '/other_bar',
        component: lazy(() => import('../../pages/Collections/OtherBars')),
        meta: {
            action: 'read',
            resource: 'collections',
        },
    },
    {
        path: '/elc_users',
        component: lazy(() => import('../../pages/Collections/ElcUsers')),
        meta: {
            action: 'read',
            resource: 'collections',
        },
    },
];

export default CollectionRoutes;
